import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter as Router } from 'react-router-dom';
import Clarity from '@microsoft/clarity';
import axios from 'axios';

import App from './App';
import { TeamsProvider } from './context/TeamsProvider';
import { installAccessGuard } from './services/access';
import { installProjectAccessGuard } from './services/projectAccess';
import { initNetworkInterceptor } from './utils/networkInterceptor';

// Initialize network interceptor for debugging
initNetworkInterceptor();

// Do not send calls the signed-in user's role may not make.
installAccessGuard(axios);

// Leave a project the moment the server says the user is no longer in it.
installProjectAccessGuard(axios);

// "ResizeObserver loop completed with undelivered notifications" happens when
// an observed element resizes itself inside its own resize callback (the
// rich-text editor in mail approval cards does). It's harmless, but the
// development overlay reports it as an uncaught error and covers the page.
// Running every ResizeObserver callback on the next animation frame breaks
// the loop, so the notice never fires.
if (typeof window !== 'undefined' && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

const Root = () => {
  const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;
  if (projectId) Clarity.init(projectId);

  return (
    <Router>
      <TeamsProvider>
        <App />
      </TeamsProvider>
    </Router>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);
